import { render } from "./FAQ.vue?vue&type=template&id=a04a0766"
const script = {}
script.render = render

export default script